import { Button, Result } from "antd";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { roles } from "../config/roles";

export const HomeLayout = () => {
  const isLogin = useSelector((state) => state.AuthReducer.isLogin);
  const role = localStorage.getItem("role");
  // console.log('===========================', role, isLogin);
  const navigate = useNavigate();
  if (isLogin == true) {
    if (role == roles.contractor) {
      return <Navigate to={"/contractorHome"} />;
    } else if (role == roles.cleaner) {
      return <Navigate to={"/cleanerHome"} />
    } else if (role == roles.customer) {
      return <Navigate to={"/customerHome"} />
    }
  }
  return (
    // <div>
      <Outlet />
    // </div>
  );
};

export const CleanerLayout = () => {
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  if (role != roles.cleaner) {
    return (
      <Result
        style={{ width: "100%" }}
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        }
      />
    );
  }
  return (
    <div>
      <Outlet />
    </div>
  );
};

export const CustomerLayout = () => {
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  if (role != roles.customer) {
    return (
      <Result
        style={{ width: "100%", padding: "0px !important" }}
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        }
      />
    );
  }
  return (
    <div>
      <Outlet />
    </div>
  );
};

export const ContractorLayout = () => {
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  if (role != roles.contractor) {
    return (
      <Result
        style={{ width: "100%", padding: "0px !important" }}
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        }
      />
    );
  }
  return (
    <div>
      <Outlet />
    </div>
  );
};


export const CommonLayout = ({ roles }) => {
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  if (!roles.includes(role)) {
    return (
      <Result
        style={{ width: "100%", padding: "0px !important" }}
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        }
      />
    );
  }
  return (
    <div>
      <Outlet />
    </div>
  );
};
